/* eslint-disable jsx-a11y/anchor-is-valid */
import Link, { LinkProps } from 'next/link';
import React from 'react';

interface PaginationLinkProps {
  href: LinkProps['href'];
  children: React.ReactElement;
}

export default function PaginationLink({ href, children }: PaginationLinkProps) {
  return <Link href={href}>{children}</Link>;
}
